import React, { useEffect,useState, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/categories/categoriesActions";
import * as crud from "../../../_redux/categories/categoriesCrud";

import * as uiHelpers from "../CategoriesUIHelpers";
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { getRowStyleByStatus } from "../../../_helpers/tableRowStatusColors";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useCategoriesUIContext } from "../CategoriesUIContext";

export function CategoriesTable() {
  const {user} = useSelector(state => state.auth);
  const userobject = user.userData;
  var superadmin = true;
  if (userobject.admin_role && userobject.admin_role !== 'superadmin' && userobject.is_admin) { superadmin = false; }

  // Categories UI Context
  const categoriesUIContext = useCategoriesUIContext();
  const categoriesUIProps = useMemo(() => {
    return {
      ids: categoriesUIContext.ids,
      setIds: categoriesUIContext.setIds,
      queryParams: categoriesUIContext.queryParams,
      setQueryParams: categoriesUIContext.setQueryParams,
      openEditCategoryPage: categoriesUIContext.openEditCategoryPage,
      openDeleteCategoryDialog: categoriesUIContext.openDeleteCategoryDialog,
    };
  }, [categoriesUIContext]);

  // Getting curret state of categories list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.categories }),
    shallowEqual
  );

  const delay = ms => new Promise(res => setTimeout(res, ms));

  const { totalCount, entities, listLoading } = currentState;
  const [processing, setProcessing] = useState('');
  const [isEdit, setisEdit] = useState('');
  const [nameValue, setNameValue] = useState('');

  // Categories Redux state
  const dispatch = useDispatch();

  const updateStatus = async (id,status) => {
    setProcessing(id)
    await crud.updateStatusForCategory(id,status);
    await delay(1000);
    dispatch(actions.fetchCategories(categoriesUIProps.queryParams));
    setProcessing('')
  };
  const isApprovalTab = ["approved", "pending", "rejected"].includes(window.location.pathname.split("/")[2]);
  const rowStyle = (row) => getRowStyleByStatus(row, isApprovalTab ? 'approval_status' : 'status');

  const editCategory = async (row) => {
    setisEdit(row.id)
    setNameValue(row.name)
  };
  
  const saveCategory = async (row) => {
    setProcessing("save" + row.id)
    await crud.updateRecordForCategory(row.id,nameValue);
    await delay(1000);
    dispatch(actions.fetchCategories(categoriesUIProps.queryParams));
    setisEdit('')
    setProcessing('')
  };

  useEffect(() => {
    // clear selections list
    categoriesUIProps.setIds([]);
    // server call by queryParams
    dispatch(actions.fetchCategories(categoriesUIProps.queryParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoriesUIProps.queryParams, dispatch]);
  // Table columns
  let columns = [
    {
      attrs: { title: 'Name' },
      dataField: "name",
      text: "Name",
      formatter: columnFormatters.NameColumnFormatter,
      formatExtraData: {
        isEdit:isEdit,
        setNameValue:setNameValue,
        nameValue:nameValue,
      },
      sort: true,
      sortCaret: sortCaret,
    },
  ];

  if (isApprovalTab) {
    columns.push({
      attrs: { title: 'Status' },
      dataField: "approval_status",
      text: "Status",
      formatter: columnFormatters.ApprovalStatusColumnFormatter,
      formatExtraData: {
        updateStatus: updateStatus,
        superadmin:superadmin,
        processing:processing,
      },
      classes: "media-action-class",
      sort: true,
      sortCaret: sortCaret,
    });
  } else {
    columns.push({
      attrs: { title: 'Status' },
      dataField: "status",
      text: "Status",
      formatter: columnFormatters.StatusColumnFormatter,
      formatExtraData: {
        updateStatus: updateStatus,
        superadmin:superadmin,
        processing:processing,
      },
      classes: "media-action-class",
      sort: true,
      sortCaret: sortCaret,
    });
  }

  // Subcategories column removed
  if(superadmin)
  {
    columns.push({
      attrs: { title: 'Actions' },
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        editCategory:editCategory,
        saveCategory:saveCategory,
        isEdit:isEdit,
        processing:processing,
        setisEdit:setisEdit,
      },
      
      style: {
        minWidth: "100px",
      },
    })
  }
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: categoriesUIProps.queryParams.pageSize,
    page: categoriesUIProps.queryParams.pageNumber,
  };
  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="custom-res-table table table-head-custom table-head-bg table-vertical-center"
                bootstrap4
                bordered={false}
                remote
                keyField="id"
                data={entities === null ? [] : entities}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                rowStyle={ rowStyle } 
                onTableChange={getHandlerTableChange(
                  categoriesUIProps.setQueryParams
                )}
                selectRow={getSelectRow({
                  entities,
                  ids: categoriesUIProps.ids,
                  setIds: categoriesUIProps.setIds,
                })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
